import * as Sentry from '@sentry/react';

export const logToSentry = (error, user, extra, section, tags) => {
  return Sentry.captureException(error, { user, section, extra });
};
